import { useQuery } from '@tanstack/react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type {
  FetchPartFileStatusesResponse,
  FetchPartFileStatusesParams,
  FetchPartFileStatusesQueryKeyType,
} from './types';

const getFetchProcessingStatusesQueryKey = (
  params: FetchPartFileStatusesParams,
): FetchPartFileStatusesQueryKeyType => {
  return ['parts', 'statuses', params];
};

export const useFetchPartFileStatuses: QueryFunction<
  FetchPartFileStatusesResponse,
  [FetchPartFileStatusesParams],
  FetchPartFileStatusesQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getFetchProcessingStatusesQueryKey(params);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request<FetchPartFileStatusesResponse>(`/parts/statuses/`, {
        init: {
          method: 'POST',
          body: { uuids: params.uuids },
          signal,
        },
      }),
  });
};
